import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/users/")({
  head: () => ({
    meta: [{ title: "用户管理 · imiker CRM" }],
  })
});
